// NextJS implementation: https://github.com/vercel/next.js/blob/canary/packages/next/client/request-idle-callback.ts
export const requestIdleCallback = (typeof self !== 'undefined' && self.requestIdleCallback && self.requestIdleCallback.bind(window)) ||
    function(cb) {
        let start = Date.now();
        return setTimeout(() => {
            cb({
                didTimeout: false,
                timeRemaining: () => {
                    return Math.max(0, 50 - (Date.now() - start));
                },
            });
        }, 1);
    };
